import sanitize from "sanitize-html";

const isObjectEmpty = (obj: any) => {
  return obj !== null && obj !== undefined && Object.keys(obj).length === 0 && obj.constructor === Object;
};

const getKeyByValue = (obj: Record<string, any>, value: string): string | undefined => {
  const key = Object.keys(obj).find((key) => obj[key] === value);
  return key;
};

const capitalizeString = (string = "") => {
  return string?.charAt(0).toUpperCase() + string?.substring(1).toLowerCase();
};

const getPath = (url: string): string => {
  const parsed = new URL(url);
  return parsed.pathname + parsed.search + parsed.hash || "/";
};

const sanitizeField = (data: string) => {
  return sanitize(data, { allowedTags: [], allowedAttributes: {} });
};

const decodeBase64 = (value: string): string | undefined => {
  try {
    return atob(value);
  } catch {
    return undefined;
  }
};

export { isObjectEmpty, capitalizeString, getKeyByValue, getPath, sanitizeField, decodeBase64 };
